<template>
  <v-sheet class="pb-4">
    <v-row dense>
      <v-col cols="4">
        <v-checkbox
          dense
          label="Quitus"
          v-model="quitus"
          @change="changed()"
          hint="Cochez cette case si quitus a été donné au(x) liquidateur(s)"
          persistent-hint
          data-testid="quitus"
        />
      </v-col>
      <v-col cols="8">
        <v-text-field
          dense
          filled
          label="Date de l'ordonnance de dissolution"
          type="date"
          v-model="dateDissolution"
          :rules="[serverRule('radiation.dateDissolution')]"
          @input="notify('radiation.dateDissolution')"
          hint="Veuillez vérifier la date de l'ordonnance de dissolution transmise lors de la dissolution. A défaut, merci de prendre contact avec le tribunal compétent."
          persistent-hint
          data-testid="date-ordonnance-dissolution"
        />
      </v-col>
      <v-col cols="12">
        <v-textarea
          label="Observations radiation"
          filled
          v-model="commentaireRadiation"
          hint="Pour toute information complémentaire"
          persistent-hint
          :rules="[serverRule('radiation.commentaireRadiation')]"
          @input="notify('radiation.commentaireRadiation')"
          data-testid="observations-radiation"
        />
      </v-col>
    </v-row>
  </v-sheet>
</template>

<script>
import makeValueData from "@/mixins/makeValueData";
import makeRules from "@/mixins/makeRules";
import ValueDataRules from "@/mixins/ValueDataRules";
import DepotMixin from "./DepotMixin";

function mapTo(src, dest) {
  src = src || {};
  dest.quitus = src.quitus;
  dest.dateDissolution = src.dateDissolution;
  dest.commentaireRadiation = src.commentaireRadiation;
}

export default {
  mixins: [DepotMixin, makeValueData(mapTo), makeRules(), ValueDataRules],
};
</script>
